import React from 'react';
import { withTheme } from '@material-ui/core';

const Spacer = ({
  theme,
  orientation = 'vertical',
  spacing = 1,
}) => (
  <div
    style={{
      [orientation === 'vertical'
        ? 'height'
        : 'width']: theme.spacing(spacing),
    }}
  />
);

export default withTheme(Spacer);
